// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"P7-z"};